import { isBase64 } from "../contentOrBase64DecodedContent";
import { base64Uint8Array } from "./base64Uint8Array";


export const tryToGzipDecodeBase64StringOrArrayBuffer = async (content: string | ArrayBuffer) => {
	let contentArrayBuffer: ArrayBuffer;
	if (typeof content === "string") {
		if (content.length < 12 || !isBase64(content)) {
			return;
		}
		try {
			contentArrayBuffer = base64Uint8Array(content).buffer;
		} catch {
			return;
		}
	} else {
		contentArrayBuffer = content;
	}
	try {
		const gzipBlob: Blob = new Blob([contentArrayBuffer], { type: 'application/gzip' });
		const ds = new DecompressionStream('gzip');
		const decompressedStream = gzipBlob.stream().pipeThrough(ds);
		const decompressedArrayBuffer = await new Response(decompressedStream).arrayBuffer();
		return decompressedArrayBuffer;
	} catch {
		return contentArrayBuffer;
	}
};

export const tryDecodeBase64GZipToUtf8 = async (content: string | ArrayBuffer) => {
	try {
		const decompressedArrayBuffer = await tryToGzipDecodeBase64StringOrArrayBuffer(content);
		if (decompressedArrayBuffer == null) {
			return;
		}
		const utf8 = new TextDecoder("utf-8", { fatal: true }).decode(decompressedArrayBuffer);
		return utf8;
	} catch {
		return;
	}
};
